<script setup>
import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';
import { frontendURL } from 'dashboard/helper/URLHelper';

import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const getters = useStoreGetters();
const accountId = getters.getCurrentAccountId;

const actionURL = computed(() =>
  frontendURL(`accounts/${accountId.value}/settings/integrations/ovva`)
);
</script>

<template>
  <div
    class="flex flex-col flex-1 p-4 m-px outline outline-n-container outline-1 bg-n-card rounded-xl"
  >
    <div class="flex items-start justify-between">
      <div
        class="flex items-center justify-center w-12 h-12 mb-2 border rounded-md shadow-sm border-n-weak bg-n-alpha-3 dark:bg-n-alpha-2"
      >
        <Icon icon="i-lucide-plug-zap" class="size-6 text-n-slate-12" />
      </div>
    </div>
    <div class="flex flex-col flex-1 m-0">
      <div
        class="flex items-center justify-between mb-2 font-medium text-n-slate-12"
      >
        <span class="text-heading-3 text-n-slate-12">
          {{ $t('OVVA_INTEGRATIONS_MGMT.CARD.NAME') }}
        </span>
        <router-link :to="actionURL">
          <Button
            :label="$t('INTEGRATION_APPS.CONFIGURE')"
            icon="i-woot-settings"
            link
            xs
          />
        </router-link>
      </div>
      <p class="text-n-slate-11 text-body-main">
        {{ $t('OVVA_INTEGRATIONS_MGMT.CARD.DESCRIPTION') }}
      </p>
    </div>
  </div>
</template>
